<mat-form-field [style.width.%]="100" appearance="fill">
  <mat-label translate>FormulaParameters.result_cell</mat-label>
  <input matInput [(ngModel)]="cellResultValue" (change)="setDataItem()">
  <div matSuffix style="display:flex">
    <button mat-icon-button (click)="getFromCell()">
      <mat-icon>apps</mat-icon>
    </button>
  </div>
</mat-form-field>
